module.exports = __webpack_public_path__ + "img/dignity-health_1.3990e321.jpg";